import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CompanyFacade, NotificationFacade, RelatedCardFacade, ShoppingCartFacade } from '@ridango/components';
import { BaseComponent, Company } from '@ridango/core';
import { combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import Env from '@ridango/core/env';

@Component({
    templateUrl: './account-companies-page.component.html'
})
export class AccountCompaniesPageComponent extends BaseComponent implements OnInit, OnDestroy {
    companies$ = this.companyFacade.allCompanies$;
    selectedCompany$ = this.companyFacade.selectedCompany$;
    loaded$ = this.companyFacade.loaded$;

    companiesOnly$ = this.companyFacade.companiesOnly$;
    filteredDepartments$ = this.companyFacade.filteredDepartments$;

    constructor(
        @Inject('ENV') public env: Env,
        private translate: TranslateService,
        private companyFacade: CompanyFacade,
        private notification: NotificationFacade,
        private cartFacade: ShoppingCartFacade,
        private relatedCardFacade: RelatedCardFacade,
        private route: ActivatedRoute,
        private router: Router
    ) {
        super();
    }

    ngOnInit() {
        this.companyFacade.fetchAllCompanies();

        // When user is logging in and has exactly 1 company, select it and navigate to related cards.
        combineLatest([this.companies$, this.route.queryParams])
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(([companies, params]) => {
                if (params.l && companies?.length === 1) {
                    this.select(companies[0]);
                    this.router.navigate([this.translate.currentLang, 'account', 'related-cards']);
                }
            });
    }

    select(company: Company) {
        this.notification.removeAll();
        this.notification.success(this.translate.instant('LOCAL_SELECT_COMPANY_SUCCESS'));
        this.relatedCardFacade.resetRelatedCards();
        this.cartFacade.deleteCart();
        this.companyFacade.setSelectedCompany(company);
        localStorage.setItem('companyId', '' + company.id);
    }
}
